export default __webpack_public_path__ + "static/media/Sanding.1e1caeec.jpg";